/* global moment*/
angular
  .module('balanceBmPoint')
  .component('balanceBmPoint', {
    template: require('./balance-bm-point.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function balanceBmPointController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.showOrderView = $rootScope.gShowOrderView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'balance';
        $rootScope.menu = 'bmPoint';
        this.targetMonth = '';
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        const getMonths = () => {
          $resource(`${APIURL}/admin/bluemembers/balances/months`).get().$promise
            .then((data) => {
              this.months = data.months;
              this.targetMonth = data.months[0];
              this.monthChanged();
            })
            .catch((err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.monthChanged = () => {
          $resource(`${APIURL}/admin/bluemembers/balances`).get({ targetMonth: this.targetMonth }).$promise
            .then((data) => {
              this.balances = data.balances;
              this.merchantId = data.merchantId;
            })
            .catch((err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.download = () => {
          $window.open(`${APIURL}/admin/bluemembers/balances/download?targetMonth=${this.targetMonth}`, '_blank');
        };
        this.getTransactionType = (balance) => {
          if (balance.TRANSACTION_TYPE === 'A') {
            return $translate.instant('사용');
          } else if (balance.TRANSACTION_TYPE === 'C') {
            return $translate.instant('사용 취소');
          }
          return '-';
        };
        getMonths();
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/balance-bm-point/balance-bm-point.component.js